import { AutoIntegration } from "@/components/auto-integration";
import { IntegrationPreCheck } from "@/components/integrations";

/** Props Interface */
interface CheckIntegrationProps {
	onComplete: () => Promise<unknown>;
	integrationType: "webfleet";
}

export function CheckIntegration({ onComplete, integrationType }: CheckIntegrationProps) {
	/** Render */
	return (
		<IntegrationPreCheck integrationType={integrationType}>
			<AutoIntegration
				integrationType={integrationType}
				onComplete={onComplete}
			/>
		</IntegrationPreCheck>
	);
}
